module.exports = __webpack_public_path__ + "static/media/return.59e347c3.svg";